// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + {"212":"b3cb920a1aef584b","278":"20774bee4c88084c","779":"3a3e958cc7e740ea"}[chunkId] + ".js";
};